export const REVIEWS = [
    {
        translate: 'Translated from Russian',
        text: 'There is no point in writing a lot of words, it is just that with this keyword tool I managed to increase sales of even old works, replacing the keys that were once selected manually.',
        user: {
            name: 'Алексей Б.',
            role: 'Illustrator',
        }
    },
    {
        translate: 'Translated from Ukrainian',
        text: 'KeyHunter helped me improve key selection several times. In just a month, my sales increased!',
        user: {
            name: 'Иван П.',
            role: 'Illustrator',
        }
    },
    {
        translate: 'Translated from Russian',
        text: 'I used to spend hours researching keywords. Now it takes minutes and the results exceed my expectations.',
        user: {
            name: 'Мария К.',
            role: 'Illustrator',
        }
    },
]